import {Grid, Loader, Modal} from '@logistics-frontend/blocks'
import {useI18n} from '@logistics-frontend/core/i18n'
import {useCardBoundRef} from '@logistics-frontend/hooks'
import React from 'react'

import {useConfigContext} from '../config'
import {classes} from './CardAddModal.classes'
import {CardAddModalProps} from './CardAddModal.types'

const CardAddModal: React.FC<CardAddModalProps> = ({subTitle, trustUrl, onClose, isLoading = false, ...props}) => {
  const t = useI18n()
  const {lang, device, currency} = useConfigContext()
  const ref = useCardBoundRef<HTMLDivElement>(trustUrl, {
    lang,
    device,
    currency,
    className: classes.iframe,
    ...props,
  })

  return (
    <Modal className={classes.root} onClose={onClose} opened>
      <Modal.Header text={subTitle || t('phoenix.add_new_card.label')} title={t('phoenix.add_new_card.title')} />
      <Modal.Body>
        <Grid alignItems="center" className={classes.body} justify="center" container>
          {isLoading ? (
            <Grid item xs>
              <Loader size="l" fullWidth />
            </Grid>
          ) : (
            <Grid ref={ref} item xs />
          )}
        </Grid>
      </Modal.Body>
    </Modal>
  )
}

CardAddModal.displayName = 'CardAddModal'

export default React.memo(CardAddModal)
